<div
  class="modal-content ridp-modal ridp-modal--stop"
  cdkTrapFocus
  [cdkTrapFocusAutoCapture]="false"
  role="dialog"
  [attr.aria-labelledby]="'my-modal-title'"
>
  <div class="modal-header">
    <h1 id="my-modal-title" class="modal-title">
      {{ "RIDP_STOP_HEADER" | globalTranslate }}
    </h1>
  </div>
  <div class="modal-body text-center">
    <div class="error-icon-wrapper">
      <svg
        width="80"
        height="80"
        viewBox="0 0 80 80"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <circle cx="40" cy="40" r="38" stroke="#174A7C" stroke-width="4" />
        <path
          d="M25 25L55 55M55 25L25 55"
          stroke="#174A7C"
          stroke-width="4"
          stroke-linecap="round"
        />
      </svg>
    </div>
    <div class="content-section">
      <p
        class="main-text"
        [innerHTML]="'RIDP_STOP_MESSAGE_1' | globalTranslate"
      ></p>
      <p class="instruction-text">
        {{ "RIDP_STOP_INSTRUCTION_1" | globalTranslate
        }}<strong>{{ "RIDP_PENDING_BTN_CONTINUE" | globalTranslate }}</strong
        >{{ "RIDP_STOP_INSTRUCTION_2" | globalTranslate }}
      </p>
    </div>
  </div>
  <div class="modal-footer flex-column">
    <button
      type="button"
      class="btn btn-primary primary-action ms-0"
      (click)="onContinueToIdProof()"
    >
      {{ "RIDP_PENDING_BTN_CONTINUE" | globalTranslate }}
    </button>
    @if (!isMobileUser) {
    <div class="alternative-actions mt-3">
      <p class="apply-text">
        <br />{{ "RIDP_PENDING_APPLY_TEXT" | globalTranslate }} <br /><a
          tabindex="0"
          class="action-link"
          (click)="onGoToDashboard()"
          >{{ "RIDP_DASHBOARD_LINK" | globalTranslate }}</a
        >
      </p>
    </div>
    } @if (isMobileUser) {
    <div class="modal-body text-center">
      <p class="instruction-text">
        {{ "MOBILE_IDVERIFY_TEXT_02" | globalTranslate }}
      </p>
    </div>
    }
  </div>
</div>